// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DaBe","colMin":"styles_colMin__2egCV"};